import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const InventoryFilters = ({ onFilterChange, onBulkAction, selectedItems }) => {
  const [filters, setFilters] = useState({
    category: '',
    supplier: '',
    status: '',
    search: ''
  });

  const categoryOptions = [
    { value: '', label: 'All Categories' },
    { value: 'Electronics', label: 'Electronics' },
    { value: 'Office Supplies', label: 'Office Supplies' },
    { value: 'Raw Materials', label: 'Raw Materials' },
    { value: 'Packaging Materials', label: 'Packaging Materials' }
  ];

  const supplierOptions = [
    { value: '', label: 'All Suppliers' },
    { value: 'TechCorp Solutions', label: 'TechCorp Solutions' },
    { value: 'Office Pro Ltd', label: 'Office Pro Ltd' },
    { value: 'Material Masters Inc', label: 'Material Masters Inc' },
    { value: 'Eco Materials Co', label: 'Eco Materials Co' }
  ];

  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'in-stock', label: 'In Stock' },
    { value: 'low-stock', label: 'Low Stock' },
    { value: 'out-of-stock', label: 'Out of Stock' },
    { value: 'overstock', label: 'Overstock' },
    { value: 'discontinued', label: 'Discontinued' }
  ];

  const bulkActionOptions = [
    { value: '', label: 'Bulk Actions' },
    { value: 'adjust-stock', label: 'Adjust Stock' },
    { value: 'reorder', label: 'Create Reorder' },
    { value: 'update-prices', label: 'Update Prices' },
    { value: 'export-selected', label: 'Export Selected' },
    { value: 'mark-discontinued', label: 'Mark as Discontinued' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      category: '',
      supplier: '',
      status: '',
      search: ''
    };
    setFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  const handleBulkActionChange = (action) => {
    if (action && selectedItems?.length > 0) {
      onBulkAction(action, selectedItems);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Search Input */}
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by item name, SKU, or description..."
            value={filters?.search}
            onChange={(e) => handleFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Filter Dropdowns */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Select
            placeholder="Category"
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => handleFilterChange('category', value)}
            className="w-full sm:w-48"
          />

          <Select
            placeholder="Supplier"
            options={supplierOptions}
            value={filters?.supplier}
            onChange={(value) => handleFilterChange('supplier', value)}
            className="w-full sm:w-48"
          />

          <Select
            placeholder="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => handleFilterChange('status', value)}
            className="w-full sm:w-48"
          />
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={handleClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear
          </Button>
        </div>
      </div>
      {/* Bulk Actions Row */}
      {selectedItems?.length > 0 && (
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">
            {selectedItems?.length} item{selectedItems?.length !== 1 ? 's' : ''} selected
          </span>
          
          <div className="flex items-center gap-3">
            <Select
              placeholder="Choose action..."
              options={bulkActionOptions}
              value=""
              onChange={handleBulkActionChange}
              className="w-48"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InventoryFilters;